export default __webpack_public_path__ + "static/media/Software AG.99e6b061.png";